<script lang="ts">
  import { SvelteToast } from "@zerodevx/svelte-toast"

  import "../app.css"

  import Analytics from "$lib/analytics/Analytics.svelte"

  import "$lib/i18n" // Import to initialize. Important

  import { StatefulDialog } from "$lib/dialog"
  import { isAnalyticsEnabled } from "$lib/environment"
  import { setCobrowseSessionContext } from "@tastyworks/shared-cobrowse/session-store"
  import { setUiclContext } from "@tastyworks/ui-library"

  let { data, children } = $props()

  const {
    isTastyWebView,
    webViewPlatform,
    isIosAttAuthorized,
    globalErrorHandler,
  } = data

  setUiclContext({
    v2: true,
  })
  setCobrowseSessionContext()

  // show masking for content square if env variable is set
  document.body.classList.toggle(
    "outline-masked-sections",
    import.meta.env.VITE_SHOW_CS_MASKS === "true"
  )
</script>

<SvelteToast options={{ classes: ["toast"] }} />
<!--
  Runtime errors (unhandled rejections, window errors) route through the
  ErrorController, NOT SvelteKit's +error.svelte page. The account-opening flow
  enforces step validity via beforeNavigate, so navigating to /error would just
  bounce the user back. Instead the controller latches isTerminal, surfaces a
  toast, and Form.svelte blocks further submissions. +error.svelte is reserved
  for failures during the initial load (before the application flow starts).
-->
<svelte:window
  onunhandledrejection={(event) => {
    globalErrorHandler.handleError(event.reason)
  }}
  onerror={(event) => {
    if (event instanceof ErrorEvent) {
      globalErrorHandler.handleError(event.error)
    }
  }}
/>

{@render children()}

{#if isAnalyticsEnabled()}
  <Analytics
    isWebView={$isTastyWebView}
    platform={$webViewPlatform}
    isIosAttAuthorized={$isIosAttAuthorized}
  />
{/if}

<StatefulDialog />
